import React from 'react';
import Button from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import type { ClassNameMap } from '@material-ui/styles';

const Dialog: React.FC<DialogProps> = (props) => {
	const { open, onOK, onCancel, title, children, classes, style, fullWidth = true, maxWidth = false, autoFocusOk = false } = props;

	return (
		<MuiDialog
			open={open}
			disableEscapeKeyDown={true}
			classes={classes}
			style={style}
			fullWidth={fullWidth}
			maxWidth={maxWidth}
			onClose={(reason: string): void => {
				if (reason !== 'backdropClick') onCancel();
			}}>
			<MuiDialogTitle>{title}</MuiDialogTitle>
			<MuiDialogContent dividers>{children}</MuiDialogContent>
			<MuiDialogActions>
				<Button data-testid='dialog-button-cancel' onClick={onCancel}>
					Cancel
				</Button>
				<Button data-testid='dialog-button-ok' onClick={onOK} color='primary' autoFocus={autoFocusOk}>
					OK
				</Button>
			</MuiDialogActions>
		</MuiDialog>
	);
};

type DialogProps = {
	open: boolean;
	onOK: () => void;
	onCancel: () => void;
	title: string;
	children?: React.ReactNode;
	classes?: ClassNameMap;
	style?: object;
	fullWidth?: boolean;
	maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	autoFocusOk?: boolean;
};

export default Dialog;
